module.exports = __webpack_public_path__ + "img/two_single_select.4e26b2dd.png";